import { render, staticRenderFns } from "./algo-data-list.html?vue&type=template&id=86b2f1fe&scoped=true&external"
import script from "./algo-data-list.js?vue&type=script&lang=js&external"
export * from "./algo-data-list.js?vue&type=script&lang=js&external"
import style0 from "./algo-data-list.scss?vue&type=style&index=0&id=86b2f1fe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b2f1fe",
  null
  
)

export default component.exports